// extracted by mini-css-extract-plugin
export default {"container":"Header_container__eXaEm","admin":"Header_admin__1usXW","adminBack":"Header_adminBack__OCMBo"};